export default "__VITE_ASSET__CLyQzvuY__"